// extracted by mini-css-extract-plugin
export default {"sort":"PR-z","sortSelect":"QR-z","disabled":"RR-z"};